import { QueryDocumentSnapshot, DocumentSnapshot } from "firebase/firestore";

export function parseDoc<T>(doc: QueryDocumentSnapshot | DocumentSnapshot): T {
  return {
    ...doc.data(),
    id: doc.id,
  } as T;
}
